// extracted by mini-css-extract-plugin
export default {"addRowBtn":"StationScadaConfig_addRowBtn__VrEuh"};